export default __webpack_public_path__ + "static/media/form-icon-pink.85e9bd9c.svg";